import {getData, postData} from 'helpers/Helper'
import { APP_PATH, GET_CMS_LIST, UPDATE_CMS, VIEW_CMS_DETAIL } from './apiPath'
import { getCms, updateCms, viewCms} from 'store/actions/pages';
//upload image
export function getCms_(value, callback) {
    let url = `${APP_PATH}${GET_CMS_LIST}`;
    return (dispatch) => getData(url, value)
      .then((data) => {
        dispatch(getCms(data, callback));
        return data;
   });
}

//view
export function viewCms_(value, callback) {
  let url = `${APP_PATH}${VIEW_CMS_DETAIL}${value}`;
  return (dispatch) => getData(url, value)
    .then((data) => {
      dispatch(viewCms(data, callback));
      return data;
 });
}

export function updateCms_(slug, value, callback) {
  return (dispatch) => postData(`${APP_PATH}${UPDATE_CMS}${slug}`, value)
    .then((data) => {
      dispatch(updateCms(data, callback));
      return data;
    });
}
